import React, { useMemo } from 'react';
import Form from '@baidu/icloud-ui-form';
import { useProTableContext } from './context';
import { jsx as _jsx } from "react/jsx-runtime";
export function Item(props) {
  const {
    label,
    renderType,
    render,
    name,
    style,
    props: fieldItemProps,
    fieldProps
  } = props;
  const context = useProTableContext();
  const FormItemChildren = useMemo(() => {
    return ({
      context,
      ...props
    }) => (renderType ? context.renderTypes[renderType] : render)({ ...props
    }, context);
  },
  /** 组件内定义组件都小心点 */
  [renderType, render]);
  return /*#__PURE__*/_jsx("div", {
    className: "icloud-ui-pro-table-item",
    style: style,
    children: name ? /*#__PURE__*/_jsx(Form.Field, {
      label: label,
      name: name,
      selectFirst: false,
      ...fieldProps,
      children: /*#__PURE__*/_jsx(FormItemChildren, {
        context: context,
        ...fieldItemProps
      })
    }) : (renderType ? context.renderTypes[renderType] : render)(fieldItemProps, context)
  });
}
Item.displayName = "Item";
Item.defaultProps = {
  render: () => undefined,
  props: {}
};
//# sourceMappingURL=es/Item.js.map